const table = [
    {
        prop: 'nit',
        label: 'NIT',
        minWidth: 150
    },
    {
        prop: 'company',
        label: 'Nombre',
        minWidth: 150
    },
    {
        prop: 'address',
        label: 'Dirección',
        minWidth: 150
    },
    {
        prop: 'email',
        label: 'Correo',
        minWidth: 150
    },
    {
        prop: 'phone',
        label: 'Telefono',
        minWidth: 150
    },
    {
        prop: 'web_site',
        label: 'Sitio Web',
        minWidth: 200
    },
]

export default table
